import {Component} from '@angular/core';

@Component({
    selector: 'app-payment-queue',
    templateUrl: './payment-queue.component.html',
    standalone: false
})
export class PaymentQueueComponent {

}
